import { apiClient } from '~/services/api-service';
import { Id } from '~/types/common';

export const listOfLinksMicrositeAPIService = {
  getListOfLinksSite: (id: Id) => {
    return apiClient.get(`/microsite/links/${id}/`);
  },
  createListOfLinksSite: (body) => {
    return apiClient.post(`/microsite/links/`, body);
  },
  replaceListOfLinksSite: ({ id, body }: { id: Id; body: any }) => {
    return apiClient.put(`/microsite/links/${id}/`, body);
  },
  updateListOfLinksSite: ({ id, body }: { id: Id; body: any }) => {
    return apiClient.patch(`/microsite/links/${id}/`, body);
  },
  createLink: (body) => {
    return apiClient.post(`/microsite/microsite-links/links/`, body);
  },
  updateLink: (id: Id, body) => {
    return apiClient.patch(`/microsite/microsite-links/links/${id}/`, body);
  },
  deleteLink: (id: Id) => {
    return apiClient.delete(`/microsite/microsite-links/links/${id}/`);
  },
  //social networks
  createListOfLinksSocial: (body) => {
    return apiClient.post(`/microsite/microsite-links/networks-links/`, body);
  },
  updateListOfLinksSocial: (body, id: Id) => {
    return apiClient.patch(`/microsite/microsite-links/networks-links/${id}/`, body);
  },
  deleteListOfLinksSocial: (id: Id) => {
    return apiClient.delete(`/microsite/microsite-links/networks-links/${id}/`);
  },
  addImage: (body) => {
    return apiClient.post(`/microsite/microsite-links/image/`, body);
  },
  removeImage: (id: Id) => {
    return apiClient.delete(`/microsite/microsite-links/image/${id}/`);
  },
};
